import React, {FC, JSX, memo, ReactNode, useCallback, useEffect, useRef, useState} from "react";
import {Dropdown, DropdownItem, DropdownMenu} from "react-bootstrap";
import {
    SelectComponentContainer,
    SelectComponentControl,
    SelectComponentDrop,
    SelectComponentDropName, SelectComponentDropPath
} from "./SelectComponentStyle";
import {IFolder} from "../../store/sliceFiles";


type SelectComponentProps = {
    options: IFolder[]
    onSelect: (folder: IFolder) => void
}

const SelectComponent: FC<SelectComponentProps> = (props) => {
    const [showMenu, setShowMenu] = useState(false)
    const [value, setValue] = useState<string>('')
    const ref = useRef<HTMLDivElement>(null)


    useEffect(() => {
            const check = (e: any) => {
                if (showMenu && ref.current && !ref.current.contains(e.target)) {
                    setShowMenu(false)
                }
            }

            document.addEventListener("mousedown", check)
            document.addEventListener("touchend", check)
            return () => {
                document.removeEventListener("mousedown", check)
                document.removeEventListener("touchend", check)
            }
        }
        , [showMenu])

    const onMenu = useCallback((event: React.MouseEvent<HTMLInputElement>) => {
        setShowMenu(true)
    }, [showMenu])


    const onClickItem = useCallback((event: React.MouseEvent<HTMLElement>, folder: IFolder) => {
        setValue(folder.name)
        setShowMenu(false)
        props.onSelect(folder)

    }, [showMenu])


    const items = (): React.JSX.Element[] => {
        return  props.options.map(folder => {
           return( <DropdownItem onClick={(e) => onClickItem(e, folder)}>
               <SelectComponentDrop>
                   <SelectComponentDropName>{folder.name}</SelectComponentDropName>
                   <SelectComponentDropPath>{folder.path}</SelectComponentDropPath>
               </SelectComponentDrop>
            </DropdownItem>)
        })
    }


    return (
        <SelectComponentContainer>
            <SelectComponentControl type={"text"} value={value} onClick={onMenu} placeholder={"Выберите папку"}/>
            <Dropdown style={{width: "100%", height: 0}} show={showMenu} ref={ref}>
                <DropdownMenu style={{width: "100%"}}>
                    { items()}
                </DropdownMenu>
            </Dropdown>
        </SelectComponentContainer>
    )
}
export default memo(SelectComponent)
